document.addEventListener('DOMContentLoaded',function(){
  const menu=document.querySelector('.menu-toggle');
  const nav=document.querySelector('.header-nav-wrap');
  function closeMenu(){
    if(!menu||!nav)return;
    nav.classList.remove('nav-open');
    menu.setAttribute('aria-expanded','false');
    menu.setAttribute('aria-label','Főmenü megnyitása');
    const symbol=menu.querySelector('.menu-symbol');
    if(symbol)symbol.textContent='☰';
  }
  if(menu&&nav){
    menu.addEventListener('click',function(){
      const open=!nav.classList.contains('nav-open');
      nav.classList.toggle('nav-open',open);
      menu.setAttribute('aria-expanded',String(open));
      menu.setAttribute('aria-label',open?'Főmenü bezárása':'Főmenü megnyitása');
      const symbol=menu.querySelector('.menu-symbol');
      if(symbol)symbol.textContent=open?'×':'☰';
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeMenu()});
    document.addEventListener('click',function(e){
      if(!nav.contains(e.target)&&!menu.contains(e.target))closeMenu();
    });
    nav.addEventListener('click',function(e){if(e.target.closest('a'))closeMenu()});
    window.addEventListener('resize',function(){if(window.innerWidth>900)closeMenu()});
  }
  const filter=document.querySelector('[data-filter-toggle]');
  const filterPanel=document.querySelector('.filter-sidebar');
  if(filter&&filterPanel){
    filter.setAttribute('aria-expanded','false');
    filter.addEventListener('click',function(){
      const opened=filterPanel.classList.toggle('filter-open');
      filter.setAttribute('aria-expanded',String(opened));
    });
  }
  const collectionFilters=document.getElementById('CollectionFiltersForm');
  if(collectionFilters){
    function applyCollectionFilters(){
      collectionFilters.querySelectorAll('input[type="number"]').forEach(function(input){
        input.disabled=input.value.trim()==='';
      });
      if(collectionFilters.requestSubmit)collectionFilters.requestSubmit();
      else collectionFilters.submit();
    }
    collectionFilters.addEventListener('change',function(event){
      if(event.target.matches('input[type="checkbox"],input[type="number"]'))applyCollectionFilters();
    });
    collectionFilters.addEventListener('submit',function(){
      collectionFilters.querySelectorAll('input[type="number"]').forEach(function(input){
        input.disabled=input.value.trim()==='';
      });
    });
  }
  const main=document.getElementById('ProductMainImage');
  if(main)document.querySelectorAll('.product-thumb').forEach(function(button){
    button.addEventListener('click',function(){
      const img=main.querySelector('img');
      if(img){img.src=button.dataset.imageUrl;img.removeAttribute('srcset')}
    });
  });
});